import { MultiLanguageString } from '@/lib/api/stays/types/shared-types'
import { stListingTypesRepository } from '@/repositories/StListingTypesRepo'
import { StListingTypes } from '@/types'
import { useData } from '../useData'

export interface IStListingTypes {
  _mstitle: MultiLanguageString
  id: string
  stays_id: string
}

// The structured amenity item for the UI
export interface AmenityItem {
  id: string
  name: string
}

// The final grouped structure
export interface AmenityGroup {
  title: string
  items: AmenityItem[]
}

export const useStaysListingTypes = () => {
  const {
    data: stListingTypes,
    isLoading,
    error,
    refetch,
  } = useData<StListingTypes>({
    repository: stListingTypesRepository,
    fetcher: (repo) => repo.getAll(),
    queryKey: ['st_multy_unit_property_types'],
  })

  return {
    stListingTypes: (stListingTypes ?? []) as IStListingTypes[],
    isLoading,
    error,
    refetch,
  }
}
